export const useUserSettings = () => {
    // effectively keep last route in a cookie instead of server side
    const lastRouteCookie = useCookie('routes.last', { maxAge: 60 * 60 * 24 * 365 })
    const langCookie = useCookie('ui.lang',
        {
            default: () => 'uk',
            maxAge: 60 * 60 * 24 * 365
        }
    )

    return {
        get lang() {
            return langCookie.value
        },
        set lang(val) {
            langCookie.value = val
        },

        get lastRoute() {
            return lastRouteCookie.value
        },
        set lastRoute(val) {
            lastRouteCookie.value = val
        }
    }
}